<template>
  <v-container grid-list-xl fluid>
    <confirm ref="confirm"></confirm>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title>
        <span class="title">Órdenes de Compra Reporte Mensual - Mercado Público</span>
        <v-spacer></v-spacer>
         <v-flex class="sm2 pt-0 pr-0 mt-0 mr-0">
         <v-select
                    :items="mesesLista"
                    label="Mes Reporte"
                    v-model="mesSeleccion" style="width:200px;"
                     @change="refresh()"
                  ></v-select> </v-flex>
        
          <v-btn
                            fab
                            dark
                            small
                           color="primary"
                           style="margin:0px"
                           @click="refresh()"
                          > 
                            <v-icon dark  >refresh</v-icon>
                          </v-btn>
      </v-card-title>
       <v-divider></v-divider>
      <v-card-text class="text-center">
            
            <div class="text-center">
             <v-progress-circular
            :size="150"
            :width="10"
            color="blue"
            indeterminate 
           v-if="!graphHistorialOC"
           
          ></v-progress-circular>
            </div>
             <line-chart v-if="graphHistorialOC" chart-id="line-historial-mensual" :chart-data="dataGasco"  :chart-labels="labelsHistorial"  
                :chart-abastible="dataAbastible" :chart-lipigas="dataLipigas" :options="{responsive: true, maintainAspectRatio: false}" /> 
                 
          </v-card-text>
    </v-card>
    <v-layout row wrap>      
       
      <v-flex xs4>
        <v-card>
      <v-card-title>
        <span class="title">Distribución OC - Regional - {{ EMPRESA_1 }}</span>
        <v-spacer></v-spacer>
         
      </v-card-title>
       <v-divider></v-divider>
      <v-card-text class="text-center">
            
            <div class="text-center">
             <v-progress-circular
            :size="150"
            :width="10"
            color="blue"
            indeterminate 
           v-if="!graphRegionOC"
           
          ></v-progress-circular>
          <!-- 
          -->
            </div>
               <doughnut-chart v-if="graphRegionOC" chart-id="dn-gasco123" :chart-data="dataDNGasco"  :chart-labels="labelsDNGasco"  
                :chart-colors="coloresDNGasco"  :options="{responsive: false, maintainAspectRatio: true}" />  
             <v-span v-if="graphRegionOC" class="title"> Total OC Mensual : {{ totalDNGasco }}  </v-span>
          </v-card-text>
            
    </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card>
      <v-card-title>
        <span class="title">Distribución OC - Regional - {{ EMPRESA_2 }}</span>
        <v-spacer></v-spacer>
        
      </v-card-title>
       <v-divider></v-divider>
      <v-card-text class="text-center">
            
            <div class="text-center">
             <v-progress-circular
            :size="150"
            :width="10"
            color="blue"
            indeterminate 
           v-if="!graphRegionOC"
           
          ></v-progress-circular>
          <!-- 
          -->
            </div>
               <doughnut-chart v-if="graphRegionOC" chart-id="dn-gasco1234" :chart-data="dataDNAbastible"  :chart-labels="labelsDNAbastible"  
                :chart-colors="coloresDNAbastible"  :options="{responsive: true, maintainAspectRatio: false}" />  
             <v-span v-if="graphRegionOC" class="title"> Total OC Mensual : {{ totalDNAbastible }}  </v-span>
          </v-card-text>
            
    </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card>
      <v-card-title>
        <span class="title">Distribución OC - Regional - {{ EMPRESA_3 }}</span>
        <v-spacer></v-spacer>
        
      </v-card-title>
       <v-divider></v-divider>
      <v-card-text class="text-center">
            
            <div class="text-center">
             <v-progress-circular
            :size="150"
            :width="10"
            color="blue"
            indeterminate 
           v-if="!graphRegionOC"
           
          ></v-progress-circular>
          <!-- 
          -->
            </div>
               <doughnut-chart v-if="graphRegionOC" chart-id="dn-gasco1235" :chart-data="dataDNLipigas"  :chart-labels="labelsDNLipigas"  
                :chart-colors="coloresDNLipigas"  :options="{responsive: true, maintainAspectRatio: false}" />  
             <v-span v-if="graphRegionOC" class="title"> Total OC Mensual : {{ totalDNLipigas }}  </v-span>
          </v-card-text>
            
    </v-card>
      </v-flex>
    </v-layout>
     
  </v-container>
</template>
<style>
 .v-progress-circular {
    display: block;
    width: 100px;
    margin: 0 auto;
}
.comentariosHome {
  height: 260px;
  overflow-y: auto;
}
.comentarioStatusHome {
  height: 40px;
}
.comentarioStatusLineasHome.v-list--two-line .v-list__tile {
  height: 40px;
  margin-bottom: 3px;
}
.truncate {
  max-width:200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
//import LicitacionesService from "@/services/LicitacionesService";

import OrdenCompraService from "@/services/OrdenCompraService";
import Loader from "@/components/Loader";
import moment from "moment";
//import FiltrosService from "@/services/FiltrosService";
import VWidget from "@/components/VWidget";
import AppEvents from "@/eventBus";
import LineChart from '@/components/line';
import DoughnutChart  from '@/components/dognutgasco';
//import LicitacionesItems from "@/components/LicitacionesItems";
export default {
  components: {
    VWidget,
    Loader,
    LineChart,
    DoughnutChart 
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    selectCliente:  { name: process.env.VUE_APP_EMPRESA1_NOMBRE, rut: process.env.VUE_APP_EMPRESA1_RUT },
    tipoCliente: [
       { name: process.env.VUE_APP_EMPRESA1_NOMBRE, rut: process.env.VUE_APP_EMPRESA1_RUT },
        { name: process.env.VUE_APP_EMPRESA2_NOMBRE, rut: process.env.VUE_APP_EMPRESA2_RUT },
        { name: process.env.VUE_APP_EMPRESA3_NOMBRE, rut: process.env.VUE_APP_EMPRESA3_RUT}       
      ]
    ,
    EMPRESA_1: process.env.VUE_APP_EMPRESA1_NOMBRE,
    EMPRESA_2: process.env.VUE_APP_EMPRESA2_NOMBRE,
    EMPRESA_3: process.env.VUE_APP_EMPRESA3_NOMBRE,
    mesesLista: [],
    mesSeleccion: '',
    graphHistorialOC: false,
    graphRegionOC: false,
    labelsHistorial: [],
    labelsDNGasco: [],
    labelsDNAbastible: [],
    labelsDNLipigas: [],
     coloresDNGasco: [],
    coloresDNAbastible: [],
    coloresDNLipigas: [],
    dataGasco: [],
    dataAbastible: [],
    dataLipigas: [],
    dataDNGasco: [],
    dataDNAbastible: [],
    dataDNLipigas: [],
    totalDNGasco: 0,
    totalDNAbastible: 0,
    totalDNLipigas: 0,
    search: null,
    searchPendienteAceptacion: null,
    searchCancelada: null,
    loading: false,
    loadingPendiente: false,
    loadingValidacion: false,
    loadingCancelada: false,
    /*
public long Id { get; set; }
        public string Codigo { get; set; }
        public DateTime? FechaEstado { get; set; }
        public string UsuarioGestion { get; set; }
        public string EstadoGestion { get; set; }
        public string Nombre { get; set; }
        public string NombreOrganismo { get; set; }
        public DateTime? FechaEnvio { get; set; }
        public string Tipo { get; set; }
        public string TipoMoneda { get; set; }
        public float? Total { get; set; }
        public string TotalFormat    
    
    */
    detallePendiente: [],
    detallePendienteServer: [],
    detalleCanceladas: [],
    detalleCanceladasServer: [],
    detalleItems: [], 
    rowsPerPageItems: [20, 50, 100],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      sortBy: "fechaEstado",
      descending: true
    },  
    totalItems: 0,  
    headers: [
      {
        text: "Código",
        align: "left",
        sortable: true,
        value: "codigo"
      },
      {
        text: "Nombre",
        align: "left",
        sortable: true,
        value: "nombre"
      },
      {
        text: "Nombre Organismo",
        align: "left",
        sortable: true,
        value: "nombreOrganismo"
      },
      {
        text: "Región",
        align: "left",
        sortable: true,
        value: "regionUnidad"
      },
      {
        text: "Fecha Creación",
        align: "left",
        sortable: true,
        value: "fechaEstado"
      },
      {
        text: "Tipo OC",
        align: "left",
        sortable: true,
        value: "tipo"
      },
      {
        text: "Moneda",
        align: "left",
        sortable: true,
        value: "tipoMoneda"
      },
      {
        text: "Total",
        align: "left",
        sortable: true,
        value: "total"
      }, 
    ]
  }),
  methods: {
     getHumanDate (date)
    {
      if (!date) return '';
      if (date === '0001-01-01') return '';
      return  moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    findPendienteAceptacion()
    {
       var busqueda = this.searchPendienteAceptacion == null ? "" : this.searchPendienteAceptacion;
      this.detallePendiente = this.detallePendienteServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    async getEvolucionOcCliente()
    {
 /*
        dataHistorial: [],
    labelsHistorial: [],
      */
         this.graphHistorialOC = false;
          
        const response = await OrdenCompraService.getEvolucionOcClienteMensual(this.mesSeleccion).then(response => {
         
          let data = response.data;

           

         debugger;
            
            this.labelsHistorial = response.data.fechas.map(x => {
                                    return x;
                                  });  
            this.dataGasco = response.data.listadoGasco.map(x => {
              return x.precioValor;
            }); 
            this.dataAbastible = response.data.listadoAbastible.map(x => {
              return x.precioValor;
            }); 
             this.dataLipigas = response.data.listadoLipigas.map(x => {
              return x.precioValor;
            });  
           
           // this.loading = false;
           
            this.graphHistorialOC = true;
        })
        .catch(r => {
          //this.loading = false;
          this.graphHistorialOC = false;
          console.log(r.response);
        });;
       
      
    
    },
    async getEvolucionOcClienteMensualRegion()
    {
  
         this.graphRegionOC = false;
          
        const response = await OrdenCompraService.getEvolucionOcClienteMensualRegion(this.mesSeleccion).then(response => {
         
          let data = response.data;
 
         debugger;
            
            this.labelsDNGasco = response.data.regionGasco.map(x => {
                                    return x;
                                  });  
            this.labelsDNAbastible= response.data.regionAbastible.map(x => {
              return x;
            });  
            this.labelsDNLipigas = response.data.regionLipigas.map(x => {
                                    return x;
                                  });  
             this.coloresDNGasco = response.data.coloresGasco.map(x => {
                                    return x;
                                  });  
            this.coloresDNAbastible= response.data.coloresAbastible.map(x => {
              return x;
            });  
            this.coloresDNLipigas = response.data.coloresLipigas.map(x => {
                                    return x;
                                  });  
            this.dataDNGasco = response.data.listadoGasco.map(x => {
              return x.precioValor;
            }); 
             
            this.totalDNGasco = this.formatPrice(this.dataDNGasco.reduce((a, b) => a + b, 0));
            this.dataDNAbastible = response.data.listadoAbastible.map(x => {
              return x.precioValor;
            }); 
             this.totalDNAbastible = this.formatPrice(this.dataDNAbastible.reduce((a, b) => a + b, 0));
             this.dataDNLipigas = response.data.listadoLipigas.map(x => {
              return x.precioValor;
            });  
            this.totalDNLipigas = this.formatPrice(this.dataDNLipigas.reduce((a, b) => a + b, 0));
           // this.loading = false;
           
            this.graphRegionOC = true;
        })
        .catch(r => {
          //this.loading = false;
          this.graphRegionOC = false;
          console.log(r.response);
        });;
       
      
    
    },
    formatPrice(value) {
     
       
        return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    findCancelada()
    {
      var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
      this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    async refresh()
    {
       
       const graph = await this.getEvolucionOcCliente();
       const graphregion = await this.getEvolucionOcClienteMensualRegion();
    },
    irOC(codigo)
    {
       this.$router.push({
        name: "OrdenCompraDetalle",
        //params: { codigo: codigo },
        query: { codigo: codigo  }
      });
    },
    handleClick(item) {
      debugger;
    },
    calculaStatus(estado) {
      if (estado === "PENDIENTE ACEPTACION") {
        return "deep-purple darken-1";
      } else if (estado === "CANCELADA") {
        return "red";
      } else if (estado === "VALIDADA" || estado === "ACEPTADA" || estado === "RECEPCION CONFORME") {
        return "green";
      } else if (estado === "PENDIENTE VALIDACION") {
        return "blue darken-1";
      }else {
        return "grey";
      }
    },
     async getOCDashboardExcel(estado) {
      this.loadingValidacion = true;
      const response = await OrdenCompraService.getOCDashboardExcel(estado);
      this.loadingValidacion = false;
    },
     async getOCDashboardExcelHistoricoCompleto() {
      this.loadingValidacion = true;
      const response = await OrdenCompraService.buscarItemsOCFullTextExcel(this.selectCliente.rut);
      this.loadingValidacion = false;
    },
      async getOCDashboardExcelHistorico() {
      this.loadingValidacion = true;
      const response = await OrdenCompraService.getOCDashboardHistoricoExcel(null,this.selectCliente.rut);
      this.loadingValidacion = false;
    },
    async getMesesInfo()
    {
       
         
       
       
      const response = await OrdenCompraService.getMesesBusqueda(
         
      )
        .then(r => {
          debugger;
           
          this.mesesLista = r.data.meses;
          this.mesSeleccion = r.data.mesActual;
          
        })
        .catch(r => {
          console.log(r.response);
        });






      //-----  
      /*
       this.loadingValidacion  = true;
      const response = await OrdenCompraService.getOCDashboard("RECEPCION CONFORME").then(r => {
         debugger;
        
        this.detalleItems = r.data;
         this.loadingValidacion  = false;
      });
      */
     

    },
    async getOCAceptadas()
    {
       
        let paging = this.pagination;
      let sort = paging.sortBy === null ? "fechaEstado" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;

        debugger;
        this.loadingValidacion = true;
        var busqueda = (this.search == null ? '' : this.search);
      const response = await OrdenCompraService.getOCDashboardHistoricoPaging(
        
        paginacion ,
        busqueda,
        null,
         this.selectCliente.rut
      )
        .then(r => {
          debugger;
          this.detalleItems = r.data.data;
          this.totalItems = r.data.totalCount;
          this.loadingValidacion = false;
        })
        .catch(r => {
          console.log(r.response);
        });






      //-----  
      /*
       this.loadingValidacion  = true;
      const response = await OrdenCompraService.getOCDashboard("RECEPCION CONFORME").then(r => {
         debugger;
        
        this.detalleItems = r.data;
         this.loadingValidacion  = false;
      });
      */
     

    },
    async getOCCanceladas()
    {
       
      this.loadingCancelada  = true;
       const response = await OrdenCompraService.getOCDashboard("RECEPCION CONFORME").then(r => {
   
         debugger;
        this.detalleCanceladasServer = r.data;
        var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
         if(busqueda.length > 0)
         {
            this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
         }
         else
         {
             this.detalleCanceladas = r.data;
         }
       
        
         this.loadingCancelada  = false;
      });
     

    },
    async getOCPendienteValidacion()
    {
       
      this.loadingValidacion  = true;
      const response = await OrdenCompraService.getOCDashboard("RECEPCION CONFORME").then(r => {
         debugger;
        
        this.detalleItems = r.data;
         this.loadingValidacion  = false;
      });
     

    },
    async getAllData()
    {
      const response = await this.getOCAceptadas();
      
             
    }
  },
  created()
  {

     AppEvents.$on('APP_REFRESH_DASHBOARD', (accion) => {
       console.log("ACTUALIZACION DASHBOARD " + accion.accion +" " + accion.codigo )
       const response = this.getAllData();
    });
  }
  ,
  async mounted() {
     /*this.$refs.navidad
              .open("Saludo de navidad", "saludo de navidad", {
                color: "orange",
                width: 800
              })
              .then(confirm => {
                if (confirm) {
                   
                }
              });*/
              const meses = await this.getMesesInfo();
              
              const graph = await this.getEvolucionOcCliente();
              const graphregion = await this.getEvolucionOcClienteMensualRegion();
  },
  
};
</script>
